import React, { useState } from "react";
import "./ROASPNOCalculator.css";

const ROASPNOCalculator: React.FC = () => {
  const [inputValue, setInputValue] = useState<string>("");

  const calculateResult = () => {
    const inputNumber = parseFloat(inputValue);
    if (inputValue === "-0") return "Mínus nula? 🤔 Vážně? 🥲";
    if (isNaN(inputNumber)) return "Zadej platné číslo";
    if (inputNumber === 0)
      return "Tak logicky... když tu dáš nulu, tak to bude zase nula 🤷‍♂️";
    if (inputNumber < 0) return "Tak do mínusu asi taky nepůjdeme, že jo? 🤷‍♂️";
    return `Přepočet: ${((100 / inputNumber) * 100).toFixed(2)}`;
  };

  const result = calculateResult();
  const isValidResult =
    !isNaN(parseFloat(inputValue)) && parseFloat(inputValue) > 0;

  return (
    <div className="roas-calculator">
      <h2>Převodník PNO / ROAS</h2>
      <form onSubmit={(e) => e.preventDefault()}>
        <div>
          <label htmlFor="inputValue">Zadej hodnotu:</label>
          <input
            type="number"
            id="inputValue"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            step="any"
            required
            autoFocus
          />
        </div>
      </form>
      <div id="result" className={isValidResult ? "result-button" : ""}>
        {result}
      </div>
    </div>
  );
};

export default ROASPNOCalculator;
